import { Dialog } from "@smartsuite/react-ui/lib/components/modals/Dialog";
import { ModalOverlay } from "@smartsuite/react-ui/lib/components/modals/ModalOverlay/ModalOverlay";
import { type FC, memo } from "react";

interface CloseConfirmationDialogProps {
  onConfirm: () => void;
  onCancel: () => void;
  onBlur: () => void;
}

const CloseConfirmationDialogRaw: FC<CloseConfirmationDialogProps> = ({
  onConfirm,
  onCancel,
  onBlur,
}) => {
  return (
    <ModalOverlay active={true} onClose={onBlur}>
      <Dialog.Wrapper type="warning">
        <Dialog.Image background="red" url="/question.svg" />
        <Dialog.Header>
          <Dialog.Header.Heading text="Are you sure?" />
          <Dialog.Header.Description text="Are you sure you want to exit without saving the changes you made?" />
        </Dialog.Header>
        <Dialog.Footer>
          <Dialog.Footer.ConfirmButton
            warningBackground
            text="Exit without Saving"
            onClick={onCancel}
          />
          <Dialog.Footer.ConfirmButton
            successBackground
            text="Save Changes"
            onClick={onConfirm}
          />
        </Dialog.Footer>
      </Dialog.Wrapper>
    </ModalOverlay>
  );
};

export const CloseConfirmationDialog = memo(CloseConfirmationDialogRaw);
